import ReactGA from "react-ga4";
import LandscapeAd from "../Components/Advertisement/LandscapeAd";

function Trivia(){
    ReactGA.send({
    hitType: "pageview",
    page: "/trivia",
    title: "Trivia",
  });
  return (
    <>
      <LandscapeAd />
    </>
  )
}
export default Trivia;